import Image from 'next/image';
import { FC } from 'react';
import type { HeroDefaultProps } from '.';

export type HeroWithImage = {
  image: { src: string; alt: string; width: number; height: number; frame: boolean };
  video: never;
  scene: never;
  content: never;
} & HeroDefaultProps;

const ImageAsset: FC<{ image: HeroWithImage['image'] }> = ({ image }) => {
  return (
    <div className="flex items-center justify-center my-14 lg:my-0">
      {image.frame ? (
        <div className="flex p-4 bg-white rounded-lg bg-opacity-20 backdrop-blur">
          <Image
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
            layout="intrinsic"
            quality={100}
            priority
            loading="eager"
            className="rounded-xl"
          />
        </div>
      ) : (
        <Image
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          layout="intrinsic"
          quality={100}
          priority
          loading="eager"
        />
      )}
    </div>
  );
};

export default ImageAsset;
